import AuditLogList from './audit-log.list';

export default {
  list: AuditLogList,
};
